import React from "react";

const StatusBadge = ({
  status = "",
  type = "default"
}) => {

  const normalized = String(status).toUpperCase();

  const styles = {
    VERIFIED: {
      bg: "#ecfdf5",
      color: "#059669",
      border: "#059669",
      text: "✓ Verified"
    },

    APPROVED: {
      bg: "#ecfdf5",
      color: "#059669",
      border: "#059669",
      text: "Approved"
    },

    ACTIVE: {
      bg: "#ecfdf5",
      color: "#059669",
      border: "#059669",
      text: "Active"
    },

    PENDING: {
      bg: "#fffbeb",
      color: "#d97706",
      border: "#d97706",
      text: "Pending"
    },

    UNVERIFIED: {
      bg: "#fffbeb",
      color: "#d97706",
      border: "#d97706",
      text: "Unverified"
    },

    REJECTED: {
      bg: "#fef2f2",
      color: "#dc2626",
      border: "#dc2626",
      text: "Rejected"
    },

    INACTIVE: {
      bg: "#fef2f2",
      color: "#dc2626",
      border: "#dc2626",
      text: "Inactive"
    }
  };

  const current = styles[normalized] || {
    bg: "#f3f4f6",
    color: "#6b7280",
    border: "#d1d5db",
    text: status
  };

  return (
    <span
      style={{
        backgroundColor: current.bg,
        color: current.color,
        border: `1px solid ${current.border}`,
        padding: "4px 14px",
        borderRadius: "20px",
        fontSize: "clamp(10px, 1.2vw, 12px)",
        fontWeight: "600",
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        whiteSpace: "nowrap"
      }}
    >
      {current.text}
    </span>
  );
};

export default StatusBadge;